  document.addEventListener('DOMContentLoaded', function () {
    const hiddenItems = document.querySelectorAll('.collection-title.hidden');
    let isExpanded = false;
    const showMoreButton = document.querySelector('#more_button');
    const showLessButton = document.querySelector('#less_button');

    function switchButton() {
        if (isExpanded) {
          showLessButton.classList.add('hide-button');
          hiddenItems.forEach(function (item) {
            item.classList.add('hidden');
          });
          showMoreButton.classList.remove('hide-button');
        } else {
          showMoreButton.classList.add('hide-button');
          hiddenItems.forEach(function (item) {
            item.classList.remove('hidden');
          });
          showLessButton.classList.remove('hide-button');
        }
        isExpanded = !isExpanded;
    }
    
    if (showMoreButton) {
      showMoreButton.addEventListener('click', function() {
        switchButton()
      });

      showLessButton.addEventListener('click', function() {
        switchButton()
      });
    }
  });

  
